import productsModuleFactory from '@/products/store/productsModuleFactory';
import { MineralFertilizer, ProductCategoryType } from '@/shared/api/rest/models';

const productsModuleStore = productsModuleFactory<MineralFertilizer>(ProductCategoryType.MINERAL_FERTILIZER);

export default productsModuleStore;
